import { MapPin, MessageCircle, Phone, Sparkles, Star } from "lucide-react";
import { GOOGLE_REVIEWS, MAPS_LINK, PHONE_TEL, WA_NUMBER } from "../data/site";
import { trackEvent } from "../lib/track";

const waInfo = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent("Merhaba Lunessa Spa Masaj, randevu hakkında bilgi almak istiyorum.")}`;
const waCredit = `https://wa.me/905324751871?text=${encodeURIComponent("Merhaba Bana Bi Media, web sitesi ve dijital çözümler hakkında bilgi almak istiyorum.")}`;

export default function AppDock() {
  return (
    <footer className="app-footer">
      <nav className="app-dock" aria-label="Hızlı iletişim" data-testid="app-dock">
        <a href={`tel:${PHONE_TEL}`} onClick={() => trackEvent("phone_click", { location: "dock" })} data-testid="dock-phone">
          <Phone size={19} />
          <span className="dock-text">
            <strong>Telefon</strong>
            <small>0535 795 20 58</small>
          </span>
        </a>
        <a
          href={waInfo}
          target="_blank"
          rel="noreferrer"
          onClick={() => trackEvent("whatsapp_click", { location: "dock" })}
          data-testid="dock-whatsapp"
        >
          <MessageCircle size={19} />
          <span className="dock-text">
            <strong>WhatsApp</strong>
            <small>0535 795 20 58</small>
          </span>
        </a>
        <a href={MAPS_LINK} target="_blank" rel="noreferrer" data-testid="dock-location">
          <MapPin size={19} />
          <span className="dock-text">
            <strong>Konum</strong>
            <small>Kızılırmak 27. Sk. No:2B</small>
          </span>
        </a>
        <a href={GOOGLE_REVIEWS} target="_blank" rel="noreferrer" data-testid="dock-reviews">
          <Star size={19} />
          <span className="dock-text">
            <strong>Yorumlar</strong>
            <small>Google'da Puanla</small>
          </span>
        </a>
      </nav>
      <a
        className="dock-credit"
        href={waCredit}
        target="_blank"
        rel="noreferrer"
        aria-label="Bana Bi Media - Web Sitesi ve Dijital Çözümler, WhatsApp ile yazın"
        data-testid="credit-badge"
      >
        <Sparkles size={11} />
        <span>Web Sitesi ve Dijital Çözümler — Bana Bi Media · 0532 475 18 71</span>
      </a>
    </footer>
  );
}
